import Vue from "vue";
import router from "@/routers";
import sensors from "sa-sdk-javascript";
sensors.init({
	sdk_url: "https://lib.cmbi.info/sensorsdata.min.js",
	heatmap_url: "https://lib.cmbi.info/heatmap.min.js",
	name: "sensors",
	server_url: process.env.sc,
	batch_send: true,
	use_app_track: true,
	show_log: process.env.CURRENT_MODE !== "prod",
	heatmap: {
		clickmap: "default", //自动采集点击事件
		scroll_notice_map: "not_collect", // DEV-1468 不自动自动采集视区停留WebStay事件
		scroll_delay_time: 4000,
		is_track_single_page: true
	}
});

router.afterEach((to, from) => {
	Vue.nextTick(() => {
		sensors.quick("autoTrackSinglePage", {
			title: (to.meta && to.meta.subtitle) || (to.query && decodeURIComponent(to.query.typeName || ""))
		});
	});
});
